import React from 'react';
import { twMerge } from 'tailwind-merge';
import classNames from 'classnames';

function ButtonSecondary({
  children,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  ...rest
}) {
  return (
    <div {...rest}>
      <button
        onClick={onClick}
        disabled={disabled}
        type={type}
        className={twMerge(
          classNames(
            'flex h-[55px] items-center shadow-md rounded bg-secondary-cta py-2 px-3',
            'font-aw-sans font-bold text-secondary-cta-text border-2 border-secondary-cta lg:py-4 lg:px-6',
            'disabled:bg-gray-100 disabled:border-gray-200 disabled:text-aw-midnight',
            'hover:bg-secondary-cta-text hover:text-secondary-cta hover:border-secondary-cta-text'
          ),
          className
        )}
      >
        {children}
      </button>
    </div>
  );
}

export default ButtonSecondary;
